import React, { useEffect } from 'react';
import '../styles/LegalPages.css';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-date">Last Updated: January 26, 2026</p>
        </div>
        <div className="legal-content" style={{ opacity: 0, animation: 'fadeUp 0.8s ease forwards' }}>
          <p>CVEarity respects your privacy and is committed to protecting personal information collected through cvearity.com. This Privacy Policy explains how information is collected, used, stored, and protected when you access or use the website.</p>

          <h2>1. Introduction</h2>
          <p>This Privacy Policy applies solely to the CVEarity website operated by Cybertix. CVEarity provides publicly accessible information related to CVEs, vendors, and products for informational and security awareness purposes.</p>

          <h2>2. Information We Collect</h2>
          
          <h3>2.1 Automatically Collected Information</h3>
          <p>When you visit cvearity.com, certain information may be collected automatically, including:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Device and operating system information</li>
            <li>Date and time of access</li>
            <li>Pages visited and basic usage logs</li>
            <li>Query metadata</li>
          </ul>
          <p>This information is collected for security, performance monitoring, and abuse prevention purposes.</p>

          <h3>2.2 Information You Voluntarily Provide</h3>
          <p>We may collect limited personal information only if you choose to provide it, such as:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Organization name</li>
            <li>Account credentials</li>
            <li>Contact details</li>
            <li>Messages or inquiries sent through contact forms</li>
          </ul>
          <p>Providing this information is entirely voluntary.</p>

          <h3>2.3 Lookup Data</h3>
          <p>We may collect information related to your use of our services:</p>
          <ul>
            <li>CVE queries</li>
            <li>Vendor searches</li>
            <li>Product searches</li>
            <li>Search behavior</li>
          </ul>

          <h2>3. Purpose of Data Collection</h2>
          <p>Data is collected for:</p>
          <ul>
            <li>Service delivery</li>
            <li>Platform security</li>
            <li>Abuse prevention</li>
            <li>Performance optimization</li>
            <li>Analytics</li>
            <li>Compliance</li>
            <li>Legal obligations</li>
            <li>Threat detection</li>
          </ul>

          <h2>4. How We Use Information</h2>
          <p>Information collected by CVEarity may be used to:</p>
          <ul>
            <li>Operate and maintain the website</li>
            <li>Respond to inquiries and communications</li>
            <li>Monitor and prevent abuse, fraud, or malicious activity</li>
            <li>Improve website stability, performance, and security</li>
            <li>Comply with applicable legal obligations</li>
            <li>Platform improvement</li>
            <li>Security analytics</li>
            <li>Threat intelligence</li>
            <li>Risk modeling</li>
            <li>Research</li>
          </ul>

          <h2>5. Data Usage</h2>
          <p><strong>User data shall not be sold.</strong></p>
          <p>Data may be used for:</p>
          <ul>
            <li>Platform improvement</li>
            <li>Security analytics</li>
            <li>Threat intelligence</li>
            <li>Risk modeling</li>
            <li>Research</li>
          </ul>

          <h2>6. Data Sharing and Disclosure</h2>
          <p>CVEarity does not sell, rent, or trade personal information.</p>
          <p>Information may be disclosed only:</p>
          <ul>
            <li>When required by law, regulation, or legal process</li>
            <li>To protect the rights, safety, or security of Cybertix, CVEarity, or users</li>
            <li>To trusted service providers strictly for website operations, subject to confidentiality obligations</li>
            <li>With authorized service providers</li>
            <li>For compliance obligations</li>
            <li>For security incident response</li>
          </ul>

          <h2>7. Data Retention</h2>
          <p>Information is retained only for as long as necessary to:</p>
          <ul>
            <li>Fulfill the purposes outlined in this Policy</li>
            <li>Maintain security logs</li>
            <li>Comply with legal or regulatory requirements</li>
            <li>Operational purposes</li>
            <li>Legal compliance</li>
            <li>Security auditing</li>
            <li>Regulatory obligations</li>
          </ul>

          <h2>8. Data Security</h2>
          <p>CVEarity implements reasonable administrative, technical, and organizational safeguards to protect information against unauthorized access, alteration, disclosure, or destruction.</p>
          <p>Security measures include:</p>
          <ul>
            <li>Encryption</li>
            <li>Access control</li>
            <li>Monitoring</li>
            <li>Logging</li>
            <li>Infrastructure security</li>
            <li>Secure authentication</li>
          </ul>
          <p>However, no method of transmission or storage is completely secure.</p>

          <h2>9. Cookies and Tracking Technologies</h2>
          <p>CVEarity may use limited cookies or similar technologies strictly for:</p>
          <ul>
            <li>Session management</li>
            <li>Basic analytics</li>
            <li>Security and performance optimization</li>
            <li>Authentication</li>
            <li>Performance optimization</li>
          </ul>
          <p>CVEarity does not use cookies for advertising or behavioral profiling.</p>

          <h2>10. Your Rights</h2>
          <p>Depending on applicable laws, you may have the right to:</p>
          <ul>
            <li>Request access to your personal information</li>
            <li>Request correction or deletion of your information</li>
            <li>Withdraw consent where applicable</li>
            <li>Access their data</li>
            <li>Request correction</li>
            <li>Request deletion (subject to legal obligations)</li>
          </ul>
          <p>Requests may be subject to legal and operational limitations.</p>

          <h2>11. International Users</h2>
          <p>Your information may be processed or stored in jurisdictions outside your country of residence, in accordance with applicable data protection laws. Data may be processed across jurisdictions in compliance with applicable data protection laws.</p>

          <h2>12. Children's Privacy</h2>
          <p>CVEarity is not intended for individuals under the age of 18. No information is knowingly collected from children. Services are not intended for individuals under 18 years of age.</p>

          <h2>13. Changes to This Policy</h2>
          <p>CVEarity may update this Privacy Policy from time to time. Continued use of the website constitutes acceptance of the updated Policy. This Privacy Policy may be updated periodically.</p>

          <h2>14. Contact Information</h2>
          <p>For privacy-related questions, concerns, or legal inquiries:</p>
          <p>
            <strong>Entity:</strong> Cybertix<br/>
            <strong>Product:</strong> CVEarity<br/>
            <strong>Email:</strong> legal@cvearity.com<br/>
            <strong>Website:</strong> cvearity.com
          </p>

          <p style={{ marginTop: '3rem' }}>Effective Date: January 26, 2026</p>
        </div>
      </div>
    </main>
  );
}
